// ---------------------------
// -- ACCESSIBILITY > FOCUS --
// ---------------------------
// -- global function --

const currentLang = document.documentElement.lang
let fancyboxOptions = {
  placeFocusBack: false,
  Toolbar: {
    display: {
      left: [],
      right: ["slideshow", "thumbs", "close"],
    },
  },
  l10n: Fancybox.l10n[currentLang],
  on: {
    done: (fancybox, slide) => {
      fancyboxFocusEvent();
      reinitCursor();
    }
  }
}

const fancyboxFocusEvent = function(){
  let fancyboxButtons = document.querySelectorAll('.fancybox__nav button');
  fancyboxButtons.forEach(fancyboxBtn => {
    fancyboxBtn.addEventListener('click', function(e) {
      let fancyboxContainer = this.closest('.fancybox__carousel');
      let allElements = fancyboxContainer.querySelectorAll('.fancybox__slide');
      allElements.forEach((element) => element.removeAttribute('tabindex'));
      setTimeout(function(){
        let activeEl = fancyboxContainer.querySelector('.fancybox__slide.is-selected');
        activeEl.setAttribute('tabindex', '-1');
        activeEl.focus();
      }, 1000);
    });
  });  
}


ready(function(){
  
  // Fancybox.bind("[data-fancybox]", {});

  // -- blockGallery type gallerySlider --
  // initialize in glide.js in mount.after event to prevent cloned fancybox thumbs

  // -- blockGallery type swiperSlider --
  Fancybox.bind('.type--swiperSlider [data-fancybox]', fancyboxOptions);

  // -- blockFaces modal --
  Fancybox.bind('[data-fancybox="modalGallery"]', fancyboxOptions);
 
  // -- files --
  Fancybox.bind('[data-fancybox="imagesLinksGallery"]', fancyboxOptions);

  // -- blockBannerVideo --
  const $showVideoBtn = document.querySelector('.btn--showVideo');
  if ($showVideoBtn) {
    $showVideoBtn.addEventListener("click", () => {
      Fancybox.show([{
        src: "#banner__video__lightbox",
        type: "inline",
      }], {
        l10n: Fancybox.l10n[currentLang]
      });
    });
  }

});